import i, { keyframes as r, css as a } from "styled-components";
import t from "../../utils/colors.js";
import { device as o } from "../../utils/device.js";
const n = i.div``, h = i.div`
  padding: 32px;
  border-bottom: 8px solid ${t.blueGrey10};
`, y = i.div`
  padding: 32px;
  border-bottom: 2px solid ${t.blueGrey10};
`, g = i.div`
  padding: 32px;

  a {
    color: ${t.orange};
  }
`, x = {
  DesktopTablet: i(n)`
    display: none;
    @media ${o.isDesktop}, ${o.isTablet} {
      display: flex;
    }
  `,
  Mobile: i(n)`
    display: none;
    @media ${o.isMobile} {
      display: flex;
    }
  `
}, d = "0.5s", s = r`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`, p = (e) => !e.$showLoading && a`
      animation: ${s} ease ${d};
    `, $ = i.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`, f = i.main`
  flex-grow: 1;
  ${(e) => e.$showLoading && `display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      min-height: 50vh;`};
`, v = i.div`
  ${(e) => e.$showLoading ? a`
          position: absolute;
          animation: ${s} ease ${d};
        ` : "display: none;"}
`, b = i.div`
  height: 100%;
  ${(e) => e.$hide && `opacity: ${e.$opacity};
    pointer-events: none;
    width: 100%;
    z-index: 0;`};
  ${p}
`, w = i.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`, u = i.div`
  width: 100%;
  max-width: 90px;
  margin-right: 16px;
  margin-bottom: 16px;
  &:last-child {
    margin-right: 0;
  }
  svg {
    width: 100%;
    height: 100%;
  }
`;
export {
  b as ChildrenWrapper,
  f as Content,
  y as ContentContainer,
  x as Display,
  u as IconWrapper,
  v as LoadingSpinner,
  w as PaymentMethods,
  g as PrivacyWrapper,
  h as TopPanel,
  $ as Wrapper,
  p as animateFadeIn
};
